import { render, staticRenderFns } from "./add-business.vue?vue&type=template&id=3ab65d5a&"
import script from "./add-business.vue?vue&type=script&lang=js&"
export * from "./add-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./add-business.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./add-business.vue?vue&type=custom&index=1&blockType=graphql"
if (typeof block1 === 'function') block1(component)

export default component.exports